// @ts-nocheck
// tslint:disable
// 暂不支持
export var performance = {
  mark: function mark(_mark) {
    return null;
  },
  clearMeasures: function clearMeasures(measure) {
    return null;
  },
  clearMarks: function clearMarks(mark) {
    return null;
  },
  measure: function measure(mark, create, load) {
    return {
      duration: 0
    };
  },
  now: function now() {}
};